import { TPR_BILTMORE_AHI_DEPARTMENT_ID, TPR_BILTMORE_DEPARTMENT_ID } from "@/configuration/groups/tpr/athena";
import { TprBiltmoreAhiProviderNpi } from "@/configuration/groups/tpr/configuration";

/**
 * TPR's checklist-display bucket outcomes for Step 8 (Bucket assignment) of the reviewer
 * sync-verification checklist. Distinct from `TprReferralProcessingStatus`, which is the *live
 * automated workflow's* internal-note vocabulary — these strings are the ops-facing bucket
 * codes from TPR's real-world routing decision tree and are shown to reviewers as-is.
 */
export enum TprSyncBucket {
  CLOSED = "closed",
  SS_CARDIO = "sscardio",
  REFERRALS_CARDIOLOGY = "referralscardiology",
  BILTMORE_CARD_REFERRAL = "biltmorecardreferral",
  BILTMORE_CARD_IO_SCHED = "biltmorecardiosched",
  BILTMORE_COUMADIN = "biltmorecoumadin",
  PULMONARY_REFERRALS = "pulmonaryreferrals",
  CARDIOTHORACIC_STAFF = "cardiothoracicstaff",
}

const TPR_AHI_PROVIDER_NPIS: ReadonlySet<string> = new Set(Object.values(TprBiltmoreAhiProviderNpi));

/** Non-Camelback referrals go to `referralscardiology` when bound for AHI or an AHI provider, else `sscardio`. */
export function resolveTprNonCamelbackBucket(input: {
  departmentId: string | null | undefined;
  providerNpi: string | null | undefined;
}): TprSyncBucket.SS_CARDIO | TprSyncBucket.REFERRALS_CARDIOLOGY {
  const { departmentId, providerNpi } = input;

  if (departmentId === TPR_BILTMORE_DEPARTMENT_ID) return TprSyncBucket.SS_CARDIO;

  return departmentId === TPR_BILTMORE_AHI_DEPARTMENT_ID || TPR_AHI_PROVIDER_NPIS.has(providerNpi ?? "")
    ? TprSyncBucket.REFERRALS_CARDIOLOGY
    : TprSyncBucket.SS_CARDIO;
}
